import OLLayerTile from 'ol/layer/Tile'
import OLSourceXYZ from 'ol/source/XYZ'

import type { TileImage } from 'ol/source'

import * as PoziUtils from 'api/utils'
import type { ConfigLayerOptions } from 'config/ConfigLayer'
import { MapLayer } from 'config/MapLayer'
import type { ConfigLayerXyzTileOptions } from 'config/MapLayerXyzTile'
import { setLayerLoadDone } from 'drawer/tabs/layers/actions'

export interface ConfigLayerEsriXyzOptions extends ConfigLayerOptions {
  config: {
    tileSize: number,
    wrapX: boolean,
    url: string,
    tileUrlFunction: (tileCoord: Array<number>) => string
  }
}

export class MapLayerEsriXyz extends MapLayer {
  static createLayer (layerConf: ConfigLayerEsriXyzOptions): OLLayerTile<TileImage> {
    this.preLayer(layerConf)

    // Setup tile modification function
    // Code from https://openlayers.org/en/latest/examples/xyz-esri-4326-512.html
    layerConf.config.tileUrlFunction = function (tileCoord: Array<number>) {
      return layerConf.config.url
        .replace('{z}', tileCoord[0]?.toString())
        .replace('{x}', tileCoord[1]?.toString())
        .replace('{y}', tileCoord[2]?.toString())
    }
    layerConf.config.tileSize = 512
    layerConf.config.wrapX = true
    // Build Source
    const olSourceESRIXYZ = new OLSourceXYZ(layerConf.config)
    const xyzTileOptions: ConfigLayerXyzTileOptions = {
      title: layerConf.title,
      titleid: layerConf.titleid,
      group: layerConf.group,
      source: olSourceESRIXYZ,
      opacity: layerConf.opacity || 1,
      visible: PoziUtils.isLayerSelected(layerConf, true)
    }
    const olLayer = new OLLayerTile(xyzTileOptions)
    PoziUtils.setSourceLoaded(olLayer, olSourceESRIXYZ, layerConf)

    // Hack to mark layer as loaded once 1 tile has successfully loaded
    olSourceESRIXYZ.once('tileloadend', () => {
      window.store.dispatch(setLayerLoadDone(layerConf.titleid))
    })

    olSourceESRIXYZ.on('tileloaderror', function (event) {
      // const errorMsg = 'Layer load failed ' + layerConf.title
      // PoziUtils.gtag({
      //   category: 'data',
      //   status: 'warning',
      //   identifier: layerConf.title,
      //   action: 'ajax request',
      //   additionalInfo: errorMsg
      // })

      console.error('ESRI XYZ layer tile load error for layer ' + layerConf.title, event)
    })

    return olLayer
  }
}
